import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ScrollPositionService {
    private scrollPositionSubject = new BehaviorSubject<number>(0);
    scrollPosition$ = this.scrollPositionSubject.asObservable();
    setScrollPosition(pos: number) {
        this.scrollPositionSubject.next(pos);
    }
}